// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingOverlay_overlay__O1kAM {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, rgba(26, 95, 63, 0.95), rgba(15, 66, 41, 0.98));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(8px);
}

.LoadingOverlay_spinnerContainer__HgYts {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

/* Multi-ring spinner */
.LoadingOverlay_spinner__cIg7n {
  position: relative;
  width: 120px;
  height: 120px;
}

.LoadingOverlay_ring__Pc8fQ {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-top-color: #4ade80;
  border-radius: 50%;
  animation: LoadingOverlay_spin__VTPLz 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
}

.LoadingOverlay_ring__Pc8fQ:nth-child(2) {
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  border-top-color: #86efac;
  animation-duration: 2s;
  animation-delay: 0.2s;
}

.LoadingOverlay_ring__Pc8fQ:nth-child(3) {
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  border-top-color: #bbf7d0;
  animation-duration: 2.5s;
  animation-delay: 0.4s;
}

@keyframes LoadingOverlay_spin__VTPLz {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Loading text with shimmer */
.LoadingOverlay_loadingText__bB6Ld {
  font-size: 24px;
  font-weight: 600;
  color: white;
  letter-spacing: 2px;
  position: relative;
  overflow: hidden;
}

.LoadingOverlay_shimmer__ZDnC6 {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0.6) 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: LoadingOverlay_shimmer__ZDnC6 2s ease-in-out infinite;
}

@keyframes LoadingOverlay_shimmer__ZDnC6 {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Floating particles */
.LoadingOverlay_particles__TJTdo {
  position: absolute;
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.LoadingOverlay_particle__kAdSm {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #4ade80;
  border-radius: 50%;
  opacity: 0;
  animation: LoadingOverlay_float__3xepf 3s ease-in-out infinite;
}

.LoadingOverlay_particle__kAdSm:nth-child(1) {
  top: 10%;
  left: 20%;
  animation-delay: 0s;
}

.LoadingOverlay_particle__kAdSm:nth-child(2) {
  top: 20%;
  right: 20%;
  animation-delay: 0.8s;
}

.LoadingOverlay_particle__kAdSm:nth-child(3) {
  bottom: 20%;
  left: 30%;
  animation-delay: 1.6s;
}

.LoadingOverlay_particle__kAdSm:nth-child(4) {
  bottom: 10%;
  right: 30%;
  animation-delay: 2.4s;
}

@keyframes LoadingOverlay_float__3xepf {
  0%, 100% {
    transform: translateY(0) scale(0);
    opacity: 0;
  }
  50% {
    transform: translateY(-30px) scale(1);
    opacity: 0.8;
  }
}

/* Pulse effect */
.LoadingOverlay_spinnerContainer__HgYts::before {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(74, 222, 128, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  animation: LoadingOverlay_pulse__FEGja 2s ease-in-out infinite;
}

@keyframes LoadingOverlay_pulse__FEGja {
  0%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Loading/LoadingOverlay.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mFAAmF;EACnF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,0FAAoE;AACtE;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,gEAA0C;AAC5C;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,8DAAwC;AAC1C;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;EAClB,8DAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, rgba(26, 95, 63, 0.95), rgba(15, 66, 41, 0.98));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  backdrop-filter: blur(8px);\n}\n\n.spinnerContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n}\n\n/* Multi-ring spinner */\n.spinner {\n  position: relative;\n  width: 120px;\n  height: 120px;\n}\n\n.ring {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 4px solid transparent;\n  border-top-color: #4ade80;\n  border-radius: 50%;\n  animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;\n}\n\n.ring:nth-child(2) {\n  width: 80%;\n  height: 80%;\n  top: 10%;\n  left: 10%;\n  border-top-color: #86efac;\n  animation-duration: 2s;\n  animation-delay: 0.2s;\n}\n\n.ring:nth-child(3) {\n  width: 60%;\n  height: 60%;\n  top: 20%;\n  left: 20%;\n  border-top-color: #bbf7d0;\n  animation-duration: 2.5s;\n  animation-delay: 0.4s;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Loading text with shimmer */\n.loadingText {\n  font-size: 24px;\n  font-weight: 600;\n  color: white;\n  letter-spacing: 2px;\n  position: relative;\n  overflow: hidden;\n}\n\n.shimmer {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.6) 0%,\n    rgba(255, 255, 255, 1) 50%,\n    rgba(255, 255, 255, 0.6) 100%\n  );\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: shimmer 2s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Floating particles */\n.particles {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.particle {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background: #4ade80;\n  border-radius: 50%;\n  opacity: 0;\n  animation: float 3s ease-in-out infinite;\n}\n\n.particle:nth-child(1) {\n  top: 10%;\n  left: 20%;\n  animation-delay: 0s;\n}\n\n.particle:nth-child(2) {\n  top: 20%;\n  right: 20%;\n  animation-delay: 0.8s;\n}\n\n.particle:nth-child(3) {\n  bottom: 20%;\n  left: 30%;\n  animation-delay: 1.6s;\n}\n\n.particle:nth-child(4) {\n  bottom: 10%;\n  right: 30%;\n  animation-delay: 2.4s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) scale(0);\n    opacity: 0;\n  }\n  50% {\n    transform: translateY(-30px) scale(1);\n    opacity: 0.8;\n  }\n}\n\n/* Pulse effect */\n.spinnerContainer::before {\n  content: '';\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(74, 222, 128, 0.2) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.8;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LoadingOverlay_overlay__O1kAM`,
	"spinnerContainer": `LoadingOverlay_spinnerContainer__HgYts`,
	"spinner": `LoadingOverlay_spinner__cIg7n`,
	"ring": `LoadingOverlay_ring__Pc8fQ`,
	"spin": `LoadingOverlay_spin__VTPLz`,
	"loadingText": `LoadingOverlay_loadingText__bB6Ld`,
	"shimmer": `LoadingOverlay_shimmer__ZDnC6`,
	"particles": `LoadingOverlay_particles__TJTdo`,
	"particle": `LoadingOverlay_particle__kAdSm`,
	"float": `LoadingOverlay_float__3xepf`,
	"pulse": `LoadingOverlay_pulse__FEGja`
};
export default ___CSS_LOADER_EXPORT___;
